export const rangeSection = () => {
  if (document.querySelector('.range')) {
    const images = document.querySelectorAll('.range .bg img')
    const items = document.querySelectorAll('.range__item')
    const itemsTop = document.querySelectorAll('.range__item-top')
    const itemsBottom= document.querySelectorAll('.range__item-bottom')

    images[0].classList.add('active')
    items[0].classList.add('active')
    itemsBottom[0].style.maxHeight = `${itemsBottom[0].scrollHeight}px`

    itemsTop.forEach(function (top, index) {
      top.addEventListener('click', () => {
        items.forEach((item) => item.classList.remove('active'))
        items[index].classList.add('active')

        images.forEach((image) => image.classList.remove('active'))
        images[index].classList.add('active')

        itemsBottom.forEach(function (bottom) {
          bottom.style.maxHeight = '0px'
        })
        itemsBottom[index].style.maxHeight = `${itemsBottom[0].scrollHeight}px`
      })
    })

  }
}